import { createContext, useContext, useState } from "react";
import styled from "styled-components";
// import rocket from "assets/rocket.json";

// const Lottie = lazy(() => import("lottie-react"));

const Context = createContext();

export const useFullScreenSpinner = () => useContext(Context);

export const FullScreenSpinnerProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const showSpinner = (text = "Cargando...") => {
    setState(text);
  };

  const hideSpinner = () => {
    setState(null);
  };

  return (
    <Context.Provider value={{ isLoading: !!state, showSpinner, hideSpinner }}>
      {children}

      {state && (
        <Root>
          {/* <Suspense
            fallback={
              <div
                style={{ display: "flex", height: 250, alignItems: "center" }}
              >
                Cargando...
              </div>
            }
          >
            <Lottie animationData={rocket} loop style={{ height: 250 }} />
          </Suspense> */}

          <div style={{ display: "flex", height: 100, alignItems: "center" }}>
            Cargando...
          </div>

          <div style={{ paddingTop: 20 }}>{state}</div>
        </Root>
      )}
    </Context.Provider>
  );
};

export default FullScreenSpinnerProvider;

const Root = styled.div`
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(2px);
`;
